var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"id":"loading-root"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.$vuetify.theme.themes.light.primary,"size":148,"width":12}},[_vm._v(" 請稍候... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }